import FAQSectionI18n from "@/components/landing/shared/FAQSectionI18n";
const FAQTourismusSection = () => <FAQSectionI18n translationPrefix="industryTourismus" bgClass="bg-secondary/30" />;
export default FAQTourismusSection;
